import React from 'react';
import PropTypes from 'prop-types';
import Barbers from './Barbers';

const DynamicBarbers = props => (
  <div>
    <Barbers {...props} />
    { props.children }
  </div>
);
DynamicBarbers.propTypes = {
  children: PropTypes.node,
};
DynamicBarbers.defaultProps = {
  children: null,
};

export default DynamicBarbers;




// WEBPACK FOOTER //
// ./src/app/dynamicBooking/time/DynamicBarbers.jsx